import React, { Component } from 'react';
import { Table, Input, Button, Card } from 'semantic-ui-react';
import _ from 'lodash';

import AvatarProfile from '../../components/avatar';

const wrapperStyles = {
  marginBottom: 30,
};

const tableStyles = {
  height: '400px',
  overflow: 'scroll',
  borderBottom: 'solid 1px #d8d8d8',
};


export default class TeamTable extends Component {
  constructor() {
    super();
    this.state = {
      invited: [],
    };
  }

  getInvitationButton = (members, pending, influencer) => {
    const invited = this.state.invited;
    const invitedEmails = _.map(invited, 'email');
    const membersAndPendingAndInvited = _.concat(members, pending, invitedEmails);

    if (_.includes(membersAndPendingAndInvited, influencer.email)) {
      return (
        <Button fluid basic disabled color="green">invited</Button>
      );
    }

    return (
      <Button fluid color="green" onClick={this.localInvite} value={influencer}>invite</Button>
    );
  }

  getAddButton = (members, pending, influencer) => {
    const invited = this.state.invited;
    const invitedEmails = _.map(invited, 'email');
    const membersAndPendingAndInvited = _.concat(members, pending, invitedEmails);

    if (_.includes(membersAndPendingAndInvited, influencer.email)) {
      return (
        <Button fluid basic disabled color="blue">added</Button>
      );
    }

    return (
      <Button color="blue" fluid onClick={this.localAdd} value={influencer}>add</Button>
    );
  }

  getCampaignInvitationFromInput = input => ({
    email: input.email,
    name: input.name,
    role: 'TEAM_MEMBER',
    id: input.id,
  });

  localInvite = (e, { name, value }) => {
    const invited = this.state.invited;
    const invitation = this.getCampaignInvitationFromInput(value);
    invited.push(invitation);
    this.setState({
      invited,
    });
    this.props.onInvite(invitation);
  }

  localAdd = (e, { name, value }) => {
    const invited = this.state.invited;
    const invitation = this.getCampaignInvitationFromInput(value);
    invited.push(invitation);
    this.setState({
      invited,
    });
    this.props.onAdd(invitation);
  }

  render() {
    const { campaign, team, visible, organisationName, onSearchChange } = this.props;
    const { invited } = this.state;
    const displayStyle = visible ? {} : { display: 'none' };

    const memberEmails = campaign ? _.map(campaign.members, 'email') : [];
    const pendingEmails = campaign ? _.map(campaign.pendingInvitations, 'email') : [];

    return (
      <div style={displayStyle}>
        <div style={wrapperStyles}>
          <Card fluid>
            <Card.Content>
              <p>Use add to add your Team Member directly - no email notification will be sent.</p>
              <p>Use invite to send an email invitation (which they must accept).</p>
            </Card.Content>
          </Card>
          <Input
            fluid
            icon="search"
            placeholder="Search My Team"
            iconPosition="left"
            onChange={onSearchChange}
          />
          <div style={tableStyles}>
            { visible &&
              <Table unstackable>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan={2}>Name</Table.HeaderCell>
                    <Table.HeaderCell>Organisation</Table.HeaderCell>
                    <Table.HeaderCell>
                      Email
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
                    <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    team &&
                    _.map(team, member => (
                      <Table.Row key={member.id}>
                        <Table.Cell collapsing>
                          <AvatarProfile plain name={member.name} size={44} />
                        </Table.Cell>
                        <Table.Cell>{member.name}</Table.Cell>
                        <Table.Cell>{organisationName}</Table.Cell>
                        <Table.Cell>
                          {member.email}
                        </Table.Cell>

                        <Table.Cell collapsing>
                          { this.getAddButton(memberEmails, pendingEmails, member) }
                        </Table.Cell>

                        <Table.Cell collapsing>
                          { this.getInvitationButton(memberEmails, pendingEmails, member) }
                        </Table.Cell>

                      </Table.Row>
                    ))
                  }
                </Table.Body>
              </Table>
            }
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/team-table/index.js
 **/